import React from 'react';
import { arrayOf, string, func, node } from 'prop-types';
import { translate } from '@fiverr-private/i18n-react';
import { Tag } from '@fiverr-private/fit';
import TagsInput from '../../../../shared/TagsInput';
import { ONLY_LETTERS_NUMBERS_SPACES_REGEX } from '../../../../shared/TagsInput/constants';
import DropdownFilterWrapper from '../DropdownFilterWrapper';
import { FILTER_MAX_TAGS_COUNT } from '../../StaticFilters/TagsFilter/constants';

import classes from './index.module.scss';
import useTagsFilterDropdown from './hooks/useTagsDropdown';

const TagsDropdown = ({
    tags: propTags,
    handleApply,
    title = translate(
        'variations_display.marketplace.modal.make_your_logo.keywords_input.title'
    ),
    applyButtonColor,
    placeholder = translate(
        'variations_display.marketplace_listing.filters.tags.placeholder'
    ),
    helpText = translate(
        'variations_display.marketplace_listing.filters.tags.help_text'
    ),
}) => {
    const { tags, setTags, canClear, canApply, handleRemoveTag, handleClear } =
        useTagsFilterDropdown({ propTags });

    return (
        <DropdownFilterWrapper
            className={classes.wrapper}
            applyButtonColor={applyButtonColor}
            canClear={canClear}
            canApply={canApply}
            onClear={handleClear}
            title={title}
            onApply={() => handleApply(tags)}
        >
            <TagsInput
                onChange={setTags}
                className={classes.tagsInput}
                addOnBlur={true}
                validationRegex={ONLY_LETTERS_NUMBERS_SPACES_REGEX}
                tags={tags}
                hideTags={true}
                maxTags={FILTER_MAX_TAGS_COUNT}
                placeholder={placeholder}
            />
            <div className={classes.helpText}>{helpText}</div>
            {!!tags.length && (
                <div className={classes.tagsWrapper}>
                    {tags.map((value) => (
                        <Tag
                            className={classes.filterChip}
                            key={value}
                            size={Tag.SIZES.SMALL}
                            color={Tag.COLORS.LIGHT_GREY}
                            handleDismiss={handleRemoveTag(value)}
                        >
                            {value}
                        </Tag>
                    ))}
                </div>
            )}
        </DropdownFilterWrapper>
    );
};

TagsDropdown.propTypes = {
    tags: arrayOf(string),
    handleApply: func,
    title: node,
    placeholder: node,
    applyButtonColor: string,
    helpText: string,
};

export default TagsDropdown;
